//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import anime from 'animejs';

export default {
  name: 'Checkbox',
  props: {
    state: {
      type: String,
      default: 'empty',
    },
  },
  data() {
    return {
      empty: {
        ry: '21.916101',
        path1: 'M 133.7237,191.16901 84.241325,190.96373',
        path2: 'm 86.328058,100.82416 46.905812,0',
        color: '#666666',
      },
      on: {
        ry: '21.916101',
        path1: 'M 135.50565,126.61567 99.691538,170.71514',
        path2: 'm 83.254459,150.00175 15.768908,20.84702',
        color: '#0d9c83',
      },
      off: {
        ry: '21.916101',
        path1: 'M 131.49661,123.14116 87.129867,168.84425',
        path2: 'm 87.129863,123.14117 44.366757,45.70308',
        color: '#9c290d',
      },
      loading: {
        ry: '45.168549',
        path1: 'M 133.7237,191.16901 84.241325,190.96373',
        path2: 'm 86.328058,100.82416 46.905812,0',
        color: '#666666',
      },
      duration: 1500,
      easingMethod: 'easeOutQuint',
    };
  },
  watch: {
    state(val) {
      this.animate(this[val]);
    },
  },
  mounted() {
    this.animate(this[this.state]);
  },
  methods: {
    animate(config) {
      anime({
        targets: this.$refs.path1,
        d: config.path1,
        stroke: config.color,
        'stroke-opacity': 1,
        duration: this.duration,
        easing: this.easingMethod,
      });
      anime({
        targets: this.$refs.path2,
        d: config.path2,
        stroke: config.color,
        'stroke-opacity': 1,
        duration: this.duration,
        easing: this.easingMethod,
      });
      anime({
        targets: this.$refs.box,
        stroke: config.color,
        duration: this.duration,
        easing: this.easingMethod,
      });
    },
  },
};
